import { environment } from '~/envs/environment';

export const getMediaResourceUrl = (id: string) => {
  return [environment.api, 'media', 'resource', id].join('/');
};

export const openMediaResource = (id: string) => {
  window.open(getMediaResourceUrl(id), '_blank');
};
